'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { memo } from 'react';
import { usePanelContext } from '../context/PanelContext';
import UIDialogCloseButton from './UIDialogCloseButton';
import UIDialogHeader from './UIDialogHeader';
const UIWizardHeader = /*#__PURE__*/memo(props => {
  const {
    stepProps,
    wizardProps
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["stepProps", "wizardProps"]);

  const {
    inPanel
  } = usePanelContext();
  const stepHeading = stepProps.heading;
  const defaultHeading = wizardProps.defaultHeading;
  const heading = stepHeading || defaultHeading;
  if (heading == null) return null;
  return /*#__PURE__*/_jsxs("div", Object.assign({}, rest, {
    children: [inPanel && /*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: wizardProps.onReject,
      "data-wizard-action-name": "close"
    }), /*#__PURE__*/_jsx(UIDialogHeader, {
      className: "uiWizardHeader",
      children: /*#__PURE__*/_jsx("h2", {
        children: heading
      })
    })]
  }));
});
UIWizardHeader.propTypes = {
  stepProps: PropTypes.object.isRequired,
  wizardProps: PropTypes.object.isRequired
};
UIWizardHeader.displayName = 'UIWizardHeader';
export default UIWizardHeader;